<script lang="ts">
  import Dialog, { Actions, Content } from '@smui/dialog';
  import { getAppConfig } from '../../../common/config/app-config';
  import Icon from '../../common/components/Icon.svelte';
  import Text from '../../common/components/Text.svelte';
  import ExtraAmplienceBannerComponent from '../../common/lazy-components/ExtraAmplienceBannerComponent.svelte';
  import { getCMSComponentsFromHybrisAsync } from '../../common/services/hybris';
  import {
    closeHomeMaintenanceAtcDialog,
    homeMaintenanceAtcData,
    homeMaintenanceAtcOpen,
  } from '../store/home_maintenance_store';
  import HMAtcItem from './HMAtcItem.svelte';

  $: data = $homeMaintenanceAtcData;

  let atcBannerMetadata = null;
  let atcBanner = null;
  const cartUrl = '/cart';
  const { encodedContextPath } = getAppConfig();

  $: if ($homeMaintenanceAtcOpen) {
    // initialize the amplience banner here
    getCMSComponentsFromHybrisAsync(['extraTasheelBanner-cart']).then(res => {
      if (res?.component?.length > 0) {
        atcBannerMetadata = res.component[0];
        queueMicrotask(() => atcBanner?.onLoad());
      }
    });
    addMarginBottomToDialogContent();
  }

  let actionSection;
  let contentMarginBottomValue = '';
  function addMarginBottomToDialogContent() {
    setTimeout(() => {
      contentMarginBottomValue = getComputedStyle(actionSection).height;
    }, 500);
  }
</script>

<div>
  <Dialog
    bind:open={$homeMaintenanceAtcOpen}
    fullscreen
    aria-labelledby="fullscreen-title"
    surface$style="width:100vw;height:100dvh;max-height:100vh"
    aria-describedby="fullscreen-content"
    on:SMUIDialog:closed={closeHomeMaintenanceAtcDialog}
    class="extraDrawer-container home-maintenance-dialog"
  >
    <Content
      id="fullscreen-content"
      on:mouseenter={() => {
        document.getElementsByTagName('html')[0].style.overflow = 'hidden';
      }}
      on:mouseleave={() => {
        document.getElementsByTagName('html')[0].style.overflow = 'scroll';
      }}
    >
      {#if data}
        <div
          id="addToCartLayerHomeMaintenance"
          class="add-to-cart c_add-to-cart-popup add-to-cart-svelte"
          style:margin-bottom={contentMarginBottomValue}
        >
          <div class="c_add-to-cart-popup-content">
            <section class="add-to-cart-header-section">
              <div class="add-to-cart-item c_add-to-cart-popup-header">
                <Icon glyph="check" desktopSize={30} />
                <div class="title">
                  <Text key="extra.addtocart.greatchoice" />
                  <Text key="extra.home.service.added.to.cart" />
                </div>
              </div>
              <div class="add-to-cart-item c_add-to-cart-popup-item">
                {#each data.entries as entry}
                  <HMAtcItem {entry} />
                {/each}
              </div>
            </section>
            <div class="c_banner js-home-maintenance-atc-ampliance-banner">
              <ExtraAmplienceBannerComponent metaData={atcBannerMetadata} bind:this={atcBanner} />
            </div>
          </div>
        </div>
      {/if}
    </Content>
    <Actions>
      <div class="c_add-to-cart-popup-btns-block" bind:this={actionSection}>
        <div class="c_add-to-cart-popup-btns">
          <a
            href="{encodedContextPath}{cartUrl}"
            role="button"
            id="link-to-checkout"
            aria-labelledby="link-to-checkout c_add-to-cart-popup-btns"
            class="c_button c_button--secondary c_button--large btn-checkout js-redirect-to-checkout add-to-cart-button"
          >
            <Text key="extra.addtocart.gotocart" />
          </a>
          <!-- svelte-ignore a11y-invalid-attribute -->
          <a
            href="#"
            role="button"
            id="continue-shoping-link"
            aria-labelledby="continue-shoping-link c_add-to-cart-popup-btns"
            class="btn-continue js-popin-close"
            on:click|preventDefault={closeHomeMaintenanceAtcDialog}
          >
            <Text key="cart.page.continue" />
          </a>
        </div>
      </div>
    </Actions>
  </Dialog>
</div>

<style lang="scss">
  :global {
    .c_add-to-cart-popup-item {
      padding-bottom: 16px;
    }
  }
</style>
